import { isOperationalPaymentPlanMode } from './paymentPlanDisplay';

function parseAmount(value) {
    const parsed = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
}

export function getPaymentPlanItemPendingAmount(item) {
    if (!item) return 0;

    const pending = parseAmount(item.pending_amount);
    if (pending > 0) {
        return pending;
    }

    if (item.status === 'PAID') {
        return 0;
    }

    const amount = parseAmount(item.amount);
    const allocated = parseAmount(item.allocated_amount);
    return Math.max(0, amount - allocated);
}

export function isPaymentPlanItemPayable(item) {
    if (!item || item.status === 'PAID') {
        return false;
    }

    return getPaymentPlanItemPendingAmount(item) > 0;
}

function formatPlanItemPeriodLabel(dueDate) {
    if (!dueDate) return null;

    const dueDateStr = String(dueDate).split(/[\sT]/)[0];
    const [year, month] = dueDateStr.split('-').map(Number);

    if (!year || !month) return null;

    const label = new Date(year, month - 1, 1).toLocaleDateString('es-AR', {
        month: 'long',
        year: 'numeric',
    }).replace(' de ', ' ');

    return label.charAt(0).toUpperCase() + label.slice(1);
}

/**
 * Maps a payment plan item into the installment-like shape used by PaymentModal.
 */
export function mapPaymentPlanItemToPayableInstallment(item) {
    const pendingAmount = getPaymentPlanItemPendingAmount(item);

    return {
        number: item.number,
        isPaymentPlanItem: true,
        paymentPlanStatus: item.status,
        balance: {
            remain: {
                total: pendingAmount,
            },
        },
        dates: {
            due_date: item.due_date,
            period: item.due_date
                ? { label: formatPlanItemPeriodLabel(item.due_date) }
                : null,
        },
    };
}

/**
 * Returns the installments the customer can pay in the modal.
 * Active payment plans use plan items; otherwise regular loan installments.
 */
export function resolvePayableInstallments({ displayMode, paymentPlan, installments }) {
    if (isOperationalPaymentPlanMode(displayMode) && paymentPlan?.items?.length) {
        return paymentPlan.items
            .filter(isPaymentPlanItemPayable)
            .map(mapPaymentPlanItemToPayableInstallment);
    }

    return (installments ?? []).filter(
        (installment) => String(installment.status?.code) !== '3'
    );
}

export function hasPayableInstallments({ displayMode, paymentPlan, installments }) {
    return resolvePayableInstallments({ displayMode, paymentPlan, installments }).length > 0;
}
